import { render } from "./Discount.vue?vue&type=template&id=38c7add8&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"

import "./Discount.vue?vue&type=style&index=0&id=38c7add8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c7add8"]])

export default __exports__